if (!customElements.get('product-save-button')) {
  customElements.define(
    'product-save-button',
    class ProductSaveButton extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'wh-saved-products';
        this.button = this.querySelector('button');
        this.productId = this.dataset.productId;
        if (!this.button || !this.productId) return;

        this.sync();
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        });
      }

      ids() {
        try {
          return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        } catch (error) {
          return [];
        }
      }

      isSaved() {
        return this.ids().includes(this.productId);
      }

      sync() {
        const saved = this.isSaved();
        this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
        this.button.setAttribute('aria-label', saved ? this.dataset.labelSaved : this.dataset.labelSave);
        this.classList.toggle('is-saved', saved);
      }

      toggle() {
        const saved = this.isSaved();
        const next = this.ids().filter((id) => id !== this.productId);
        if (!saved) next.push(this.productId);
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(next));
        } catch (error) {
          // Private browsing can block writes; the heart still toggles for this visit.
        }
        this.sync();
      }
    }
  );
}
